// extracted by mini-css-extract-plugin
module.exports = {"adSlot-below_content":"styles_adSlot-below_content__eXYI1","adSlot-in_content":"styles_adSlot-in_content__BF6Wb","adSlot-interstitial":"styles_adSlot-interstitial__ilpW0"};